import '@maplibre/maplibre-gl-leaflet'
import 'maplibre-gl/dist/maplibre-gl.css'
import L from 'leaflet'
import { setWorkerUrl } from 'maplibre-gl'
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'

/**
 * MapLibre resolves its worker through `import.meta.url` with a filename it
 * computes at runtime, which no bundler can follow: without this the worker
 * 404s, the style never finishes loading and the basemap renders blank.
 */
setWorkerUrl(maplibreWorkerUrl)

/**
 * OpenFreeMap's Positron vector style: no API key, no request limits, and the
 * style URL is the only vendor-specific bit — any MapLibre-compatible provider
 * is a one-line swap from here. It replaces CARTO's raster basemap, which now
 * watermarks every tile served without an API key.
 */
const BASEMAP_STYLE = 'https://tiles.openfreemap.org/styles/positron'
/** The style's sources declare no attribution, so it is set explicitly. */
const BASEMAP_ATTRIBUTION =
	'&copy; <a href="https://openfreemap.org" target="_blank" rel="noreferrer">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/" target="_blank" rel="noreferrer">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors'

/**
 * Adds the shared basemap to a Leaflet map. The GL layer defaults to
 * `pane: 'tilePane'`, so it stays below anything drawn in the overlay pane.
 */
export const addBasemap = (map: L.Map) => {
	L.maplibreGL({
		style: BASEMAP_STYLE,
		attributionControl: { customAttribution: BASEMAP_ATTRIBUTION }
	}).addTo(map)
}
